import classnames from 'classnames';
import { Queue } from 'lib-shared-legacy-types';
import { memo } from 'react';

import { FlowMessengerNodeContactForm } from 'components/settings/components/sections/dixaMessenger/views/flow/flow.types';

import type { FlowCallNodeQueue } from '../../powerCallFlow/components/nodeTypes/queue';
import type { FlowCallNodeVoicemail } from '../../powerCallFlow/components/nodeTypes/voicemail';
import type { FlowChatNodeContactFormT } from '../../powerChatFlow/components/nodeTypes/contactform';
import type { FlowEmailNodeQueueT } from '../../powerEmailFlow/components/nodeTypes/queue';

import styles from './queueFromPayload.module.scss';

const NO_QUEUE_SELECTED = 'No queue selected';

type Props = {
  className?: string;
  extraData?: {
    queues?: Queue[] | null;
  };
  hasSettings?: boolean;
  node:
    | FlowCallNodeVoicemail
    | FlowCallNodeQueue
    | FlowChatNodeContactFormT
    | FlowEmailNodeQueueT
    | FlowMessengerNodeContactForm;
};

function QueueFromPayload({
  className,
  extraData = {},
  hasSettings,
  node: { payload },
}: Props) {
  const { queue } = payload;

  const label: undefined | null | string = queue && queue.label;
  const queueID: undefined | null | string = queue && queue.value;
  const { queues = null } = extraData;

  let queueName: string = NO_QUEUE_SELECTED;

  if (queues !== null && queueID) {
    const match = queues.find((queue: Queue) => queue.id === queueID);

    if (match) {
      queueName = match.name;
    }
  }

  if (queueName === NO_QUEUE_SELECTED && label) {
    queueName = label;
  }

  // The order of the settingsLabel entries should be unchanged
  // since it reflects the order of settings in the Queue modal.
  //
  // announcement_attributes, queue_timeout, wait_music_v2, callbackInfo
  const settingsLabel = {
    announcement_attributes: 'announce queue position',
    queue_timeout: 'timeout',
    wait_music_v2: 'custom wait music',
    callbackInfo: 'callback',
  };

  const settings = Object.entries(settingsLabel).reduce(
    (settings: string[], [key, value]): string[] => {
      const isAnnouncementAttributes = key === 'announcement_attributes';
      const data = payload[key];

      if (isAnnouncementAttributes ? data?.play_announcement : data) {
        settings.push(value);
      }

      return settings;
    },
    [],
  );

  const settingsText = settings.join(', ');

  return (
    <div className={classnames(styles.root, className)}>
      <div className={styles.queue}>
        Queue <strong>{queueName}</strong>
      </div>
      {hasSettings && (
        <div className={styles.settings}>
          Settings{' '}
          <strong>
            {settings.length > 0
              ? `${settingsText[0].toUpperCase()}${settingsText.slice(1)}`
              : 'None'}
          </strong>
        </div>
      )}
    </div>
  );
}

export default memo(QueueFromPayload);
